import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBatteryEmpty: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="battery-empty, power" maskId="round-filled-radius-0-stroke-1.5-IconBatteryEmpty"><path fillRule="evenodd" clipRule="evenodd" d="M1 5.75C1 5.33579 1.33579 5 1.75 5H19.25C19.6642 5 20 5.33579 20 5.75V8H22.25C22.6642 8 23 8.33579 23 8.75V15.25C23 15.6642 22.6642 16 22.25 16H20V18.25C20 18.6642 19.6642 19 19.25 19H1.75C1.33579 19 1 18.6642 1 18.25V5.75ZM20 14.5H21.5V9.5H20V14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBatteryEmpty;
